import * as types from "./mutation-types";

export default {
  [types.SET_ESTADOS](state, payload) {
    state.estados = payload;
  },
  [types.SET_ESTADO](state, payload) {
    state.estado = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
};
